export default function formatArtistLetter(letter: string) {
  if (letter === '_')
    return '#';

  return letter.toUpperCase();
}